var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRank2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 0.866025C15.4282 0.330127 16.5718 0.330127 17.5 0.866025L28.3564 7.13397C29.2846 7.66987 29.8564 8.66025 29.8564 9.73205V22.2679C29.8564 23.3397 29.2846 24.3301 28.3564 24.866L17.5 31.134C16.5718 31.6699 15.4282 31.6699 14.5 31.134L3.64359 24.866C2.71539 24.3301 2.14359 23.3397 2.14359 22.268V9.73205C2.14359 8.66025 2.71539 7.66987 3.64359 7.13397L14.5 0.866025Z",
    fill: "url(#paint0_linear_8661_8510)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 2.86603C15.4282 2.33013 16.5718 2.33013 17.5 2.86603L26.6244 8.13397C27.5526 8.66987 28.1244 9.66025 28.1244 10.7321V21.268C28.1244 22.3397 27.5526 23.3301 26.6244 23.866L17.5 29.134C16.5718 29.6699 15.4282 29.6699 14.5 29.134L5.37564 23.866C4.44744 23.3301 3.87564 22.3397 3.87564 21.268V10.7321C3.87564 9.66025 4.44744 8.66987 5.37564 8.13397L14.5 2.86603Z",
    fill: "url(#paint1_linear_8661_8510)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 3.86603C15.4282 3.33013 16.5718 3.33013 17.5 3.86603L25.7583 8.63397C26.6865 9.16987 27.2583 10.1603 27.2583 11.2321V20.768C27.2583 21.8397 26.6865 22.8301 25.7583 23.366L17.5 28.134C16.5718 28.6699 15.4282 28.6699 14.5 28.134L6.24167 23.366C5.31347 22.8301 4.74167 21.8397 4.74167 20.768V11.2321C4.74167 10.1603 5.31347 9.16987 6.24167 8.63397L14.5 3.86603Z",
    fill: "url(#paint2_linear_8661_8510)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2389 20H12.7389V19.168L15.9759 15.918C16.4179 15.476 16.8339 15.034 17.1719 14.501C17.8219 13.331 17.8999 11.511 16.0539 11.511C15.0269 11.511 14.2599 12.265 14.3379 13.292L12.9079 13.032C13.1549 11.316 14.3509 10.289 16.1319 10.289C17.7439 10.289 19.0699 11.251 19.0699 12.993C19.0699 14.449 18.0689 15.476 17.1069 16.438L14.6629 18.908C15.0659 18.804 15.4949 18.726 15.9109 18.726H19.2389V20Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8661_8510",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454545"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8661_8510",
    x1: 16,
    y1: 2,
    x2: 16,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A7A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8661_8510",
    x1: 16,
    y1: 3,
    x2: 16,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#757575"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRank2);
export default __webpack_public_path__ + "static/media/rank-2.423c90e028a834572c13ac0976065bd6.svg";
export { ForwardRef as ReactComponent };